import { consola } from 'consola'
import { useApi } from '@shared/api'
import type { AddBundleToCartRequest } from '@entities/product'

const logger = consola.withTag('api-bundle')

/**
 * API-клиент бандлов («Собрать набор»).
 * Базовый URL: /api/v2/cart/bundle
 */
class APIBundle {
  /**
   * Добавить собранный набор в корзину.
   * POST /api/v2/cart/bundle
   *
   * Сервер раскладывает набор в обычные товары — отдельной сущности в корзине нет.
   */
  async addBundleToCart(payload: AddBundleToCartRequest): Promise<{ message: string; cart: any }> {
    logger.debug('Adding bundle to cart', {
      bundleId: payload.bundle_id,
      baseProductId: payload.base_product_id,
      steps: payload.step_selections.length,
    })

    const response = await useApi(true).post('/cart/bundle', {
      body: {
        branch_id: Number(payload.branch_id),
        base_product_id: Number(payload.base_product_id),
        bundle_id: Number(payload.bundle_id),
        step_selections: payload.step_selections.map(s => ({
          step_id: Number(s.step_id),
          product_id: Number(s.product_id),
        })),
        // Бэк ждёт строки: id добавок ходят строками во всех остальных ручках корзины
        base_addons: (payload.base_addons ?? []).map(String),
        base_excludes: (payload.base_excludes ?? []).map(String),
      },
    })

    logger.success('Bundle added to cart', { bundleId: payload.bundle_id })
    return response.data
  }
}

export const apiBundle = new APIBundle()
export default apiBundle
